module.exports = __webpack_public_path__ + "img/qr-logo.b10244cb.svg";